export default "/bundles/assets/help_5efe14c6d7d07125b631466e06c42760.png";